export default "__VITE_ASSET__DbiIZ5ac__"